<template>
    <v-snackbar v-model="displaySnackbar" :timeout="3000" rounded class="snack-bar">
        <div class="snack-bar-container">
            <div class="img-wrapper">
                <Svg v-if="currentDetails.image" :src="currentDetails.image":class="{ 'img-error': snackType === 'error' }"
                    :fill="snackType === 'download' ? '#FFFFFF' : 'none'"></Svg>
            </div>
            <p class="content" v-if="message">{{ message }}</p>
            <p class="content" v-else>{{ currentDetails.content }}</p>
        </div>
    </v-snackbar>
</template>

<script>
import DownloadIcon from '@/assets/icons/download.svg';
import TickIcon from '@/assets/icons/tick-icon.svg';
import CloseIcon from '@/assets/icons/close.svg';
import { Eventbus } from '@/plugins/eventBus';

export default {

    data() {
        return {
            displaySnackbar: false,
            saveDetails: {
                image: TickIcon,
                content: 'Changes saved successfully'
            },
            downloadDetails: {
                image: DownloadIcon,
                content: 'Your download has started'
            },
            refineDetails: {
                image: TickIcon,
                content: 'Content modified sucessfully'
            },
            replaceTitleDetails: {
                image: TickIcon,
                content: 'Headlines replaced sucessfully'
            },
            errorDetails: {
                 image: CloseIcon,
                 content: 'Failed to save changes'
	             },
            currentDetails: {},
            message: null,
            snackType: null,
        };
    },
    methods: {
        setDetails() {
            if (this.snackType === 'save') {
                this.currentDetails = this.saveDetails;
            } else if (this.snackType === 'download') {
                this.currentDetails = this.downloadDetails;
            } else if (this.snackType === 'refine') {
                this.currentDetails = this.refineDetails;
            } else if (this.snackType === 'replace') {
                this.currentDetails = this.replaceTitleDetails;
            }else if (this.snackType === 'error') {
                 this.currentDetails = this.errorDetails;
	             }
        },
    },
    mounted() {
        this.message = null;
        Eventbus.on('commonSnackbar', (data) => {
            this.displaySnackbar = false;
            this.message = null;
            this.snackType = null;

            setTimeout(() => {
                this.snackType = data.snackType;
                if (data?.message) {
                    this.message = data.message;
                }
                if (data?.redirect) {
                    this.$router.push(data.redirect);
                }
                this.setDetails();
                this.displaySnackbar = true;
            }, 100);
        })
    }
};
</script>

<style scoped>
.snack-bar :deep(.v-snackbar--variant-elevated) {
    background: none;
    position: absolute;
    top: 145px;
    right: 0;
    min-width: 150px;
    box-shadow: none;
}

.snack-bar-container {
    display: flex;
    gap: 1em;
    align-items: center;
    background-color: white;
    border: 2px solid #FF00C3;
    border-radius: 32px;
    padding: 8px 16px;
}


.img-wrapper {
    width: 25px;
    height: 25px;
    background: linear-gradient(90deg, #FF00C3, #FF0A19, #FF7800);
    border-radius: 50%;
    padding: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.img-wrapper Svg {
    width: 12px;
    height: 12px;
}

.content {
    background: linear-gradient(90deg, #FF00C3, #FF0A19, #FF7800);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-size: 14px;
    font-weight: 500;
}
 .img-error{
     width:20px;
     height:20px;
     filter: brightness(0) invert(1)
	 }
</style>